import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';
import {
  GET_RESERVE_HISTORY_REQUEST,
  GET_RESERVE_HISTORY_SUCCESS,
  GET_RESERVE_HISTORY_FAILURE,
  GET_RESERVE_HISTORY_DETAIL_REQUEST,
  GET_RESERVE_HISTORY_DETAIL_SUCCESS,
  GET_RESERVE_HISTORY_DETAIL_FAILURE,
  PUT_CANCEL_RESERVE_REQUEST,
  PUT_CANCEL_RESERVE_SUCCESS,
  PUT_CANCEL_RESERVE_FAILURE,
  COMMON_FAILURE,
} from '../../actions';

import { reserveHistoryService } from '../../services';

// 予約履歴取得
export type GetReserveHistoryActionType = {
  type: typeof GET_RESERVE_HISTORY_REQUEST;
  visitorId: string;
  history: string[];
};

// 予約履歴明細取得
export type GetReserveHistoryDetailActionType = {
  type: typeof GET_RESERVE_HISTORY_DETAIL_REQUEST;
  visitorId: string;
  historyId: string;
  history: string[];
};

function* getReserveHistorys(
  action: GetReserveHistoryActionType | GetReserveHistoryDetailActionType,
): Generator<unknown> {
  try {
    const res = yield call(reserveHistoryService(action).getReserveHistorys);
    yield put(
      (() => {
        if (action.type === GET_RESERVE_HISTORY_REQUEST) {
          return {
            type: GET_RESERVE_HISTORY_SUCCESS,
            res,
          };
        }
        return {
          type: GET_RESERVE_HISTORY_DETAIL_SUCCESS,
          res,
        };
      })(),
    );
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put(
        (() => {
          if (action.type === GET_RESERVE_HISTORY_REQUEST) {
            return {
              type: GET_RESERVE_HISTORY_FAILURE,
              error: error.response,
            };
          }
          return {
            type: GET_RESERVE_HISTORY_DETAIL_FAILURE,
            error: error.response,
          };
        })(),
      );
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchGetReserveHistorys() {
  yield takeLatest([GET_RESERVE_HISTORY_REQUEST, GET_RESERVE_HISTORY_DETAIL_REQUEST], getReserveHistorys);
}

// 予約キャンセル
export type PutCancelReserveActionType = {
  type: typeof PUT_CANCEL_RESERVE_REQUEST;
  contentsId: number;
  scheduleId: number;
  history: string[];
};

function* putCancelReserve(action: PutCancelReserveActionType): Generator<unknown> {
  try {
    const res = yield call(reserveHistoryService(action).putCancelReserve);
    yield put({
      type: PUT_CANCEL_RESERVE_SUCCESS,
      res,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: PUT_CANCEL_RESERVE_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
      if (error.response && error.response.status >= 500) {
        action.history.push('/system-error');
      }
    }
    // action.history.push('/systemError');
  }
}

function* watchPutCancelReserve() {
  yield takeLatest(PUT_CANCEL_RESERVE_REQUEST, putCancelReserve);
}

export default function* reserveHistorySaga(): Generator<unknown> {
  yield all([fork(watchGetReserveHistorys), fork(watchPutCancelReserve)]);
}
